import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';
import "w3-css/3/w3.css";
import "./Length.css";
import {
  FromCentimeterButton,
  FromFeetButton,
  FromInchesButton,
  FromKilometersButton,
  FromMetersButton,
  FromMilesButton,
  FromYardsButton
} from "./Button";
import { getConversion } from "./length/ConversionTracker";
import { trackConversion, trackButtonClick } from "../../utils/analytics";
export default class Lengths extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Free Length Converter - Convert Meters, Feet, Inches, Miles & More | Kayannou</title>
          <meta name="description"
            content="Free online length converter. Convert between meters, feet, inches, miles, kilometers, centimeters, and yards. Fast, accurate, and easy-to-use length conversion tool." />
          <meta name="keywords"
            content="length converter, length conversion, meters to feet, inches to centimeters, miles to kilometers, length calculator, unit converter, convert length, free length converter, online length tool, centimeter, centimeters, feet, foot, inches, inch, kilometers, kilometer, meters, meter, miles, yards, yard" />
          <meta name="author" content="Kayannou" />
          <meta property="og:title" content="Free Length Converter - Convert Meters, Feet, Inches, Miles & More" />
          <meta property="og:description" content="Free online length converter. Convert between meters, feet, inches, miles, kilometers, and more. Fast and accurate." />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Free Length Converter - Convert Meters, Feet, Inches, Miles & More" />
          <meta name="twitter:description" content="Free online length converter. Convert between meters, feet, inches, miles, kilometers, and more." />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebApplication",
              "name": "Length Converter",
              "description": "Free online length converter for meters, feet, inches, miles, kilometers, and more",
              "url": "https://kayannou.com/conversion/length",
              "applicationCategory": "UtilityApplication",
              "operatingSystem": "Any",
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
              }
            })}
          </script>
        </Helmet>
        <Container />
      </div>
    );
  }
}
class Container extends Component {
  state = {
    value: "",
    operation: ""
  };
  handleConversionButton = buttonId => {
    this.setState({ operation: buttonId });
    // Track button click
    trackButtonClick(`Length: ${buttonId}`, 'Length Conversion');
  };

  handleConversionValue = inputValue => {
    this.setState({ value: inputValue });
    // Track conversion when both value and operation are present
    if (inputValue && this.state.operation) {
      trackConversion('Length', this.state.operation, 'multiple_units', inputValue);
    }
  };

  render() {
    return (
      <div className="length-conversion-container">
        <div className="conversion-content">
          <ContainerHeader
            conversionValue={this.handleConversionValue}
            conversionresult={getConversion(
              this.state.value,
              this.state.operation
            )}
          />
          <MiddleColumn id="" conversionButton={this.handleConversionButton} />
        </div>
      </div>
    );
  }
}
class ContainerHeader extends Component {
  state = {
    inputValue: "",
    isFocused: false
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.conversionValue(value);
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  clearInput = () => {
    this.setState({ inputValue: "" });
    this.props.conversionValue("");
    if (this.input) {
      this.input.focus();
    }
  };

  render() {
    let result = this.props.conversionresult;
    const { inputValue, isFocused } = this.state;

    return (
      <div className="conversion-header">
        <div className="conversion-container">
          {/* Input Section */}
          <div className="input-section">
            <div className="input-group">
              <label className="input-label">
                <i className="fa fa-arrows-h"></i>
                Length Input
              </label>
              <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${inputValue ? 'has-value' : ''}`}>
                <input
                  ref={input => (this.input = input)}
                  className="conversion-input"
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  value={inputValue}
                  name="length"
                  type="number"
                  placeholder="Enter length conversion..."
                  min="0"
                  step="any"
                />
                {inputValue && (
                  <button
                    className="clear-button"
                    onClick={this.clearInput}
                    type="button"
                    aria-label="Clear input"
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
                <div className="input-border"></div>
              </div>
            </div>
          </div>

          {/* Result Section */}
          <div className="result-section">
            <div className="result-group">
              <label className="result-label">
                <i className="fa fa-calculator"></i>
                Conversion Result
              </label>
              <div className="result-display">
                {result ? (
                  <div className="result-content">
                    <span className="result-value">{result}</span>
                    <div className="result-indicator">
                      <i className="fa fa-check-circle"></i>
                    </div>
                  </div>
                ) : (
                  <div className="result-placeholder">
                    <i className="fa fa-arrow-left"></i>
                    <span>Enter value and select type</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Visual Enhancement */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="decoration-line"></div>
        </div>
      </div>
    );
  }
}
class MiddleColumn extends Component {
  handleClickUnit = buttonId => {
    this.props.conversionButton(buttonId);
  };

  render() {
    return (
      <div className="conversion-buttons-section">
        <div className="buttons-header">
          <h3 className="section-title">
            <i className="fa fa-arrows-h"></i>
            Select Length Unit
          </h3>
          <p className="section-description">
            Choose the length unit you want to convert from
          </p>
        </div>

        <div className="conversion-buttons-grid">
          <FromCentimeterButton id="cmto" cmUnit={this.handleClickUnit} />
          <FromFeetButton id="ftto" ftUnit={this.handleClickUnit} />
          <FromInchesButton id="into" inUnit={this.handleClickUnit} />
          <FromKilometersButton id="klto" klUnit={this.handleClickUnit} />
          <FromMetersButton id="mto" mUnit={this.handleClickUnit} />
          <FromMilesButton id="mito" miUnit={this.handleClickUnit} />
          <FromYardsButton id="ydto" ydUnit={this.handleClickUnit} />
        </div>
      </div>
    );
  }
}
